import React from 'react';
import {Row, Column} from '../../global/grid/grid';

import { Title, ItemWrapper } from './styled-components';

const ItemizedList = ({data}) => {
  return (
    <div>
        <Row margins={true} style={{ alignItems: 'center' }}>
            <Column cw={12} style={{textAlign: 'center'}}>
                <Title>{data.title}</Title>
            </Column>            
                {
                    data.list.map((item, index) => {
                        return(
                            <Column key={index} cw={10} offset={1} style={{textAlign: 'center'}}>
                                <ItemWrapper>
                                    <div className="number">{item.number}</div>
                                    <div className="label">{item.label}</div>
                                </ItemWrapper>
                            </Column>
                        )
                    })
                }            
        </Row>
    </div>
  )
}

export default ItemizedList;



// WEBPACK FOOTER //
// ./src/components/modules/ItemizedList/ItemizedList.js